var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Filtro',{on:{"filtro":_vm.makeFiltro,"clear":function($event){_vm.limpar = true}}}),_c('List',{attrs:{"filtro":_vm.filtro,"realizaFiltro":_vm.realizaFiltro,"subjectPermission":_vm.subjectPermission,"limpar":_vm.limpar},on:{"filtroOk":_vm.finalizaFiltro,"limpouFiltro":function($event){_vm.limpar = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }